import EntityDisplay from '../EntityElements/EntityDisplay';
import { hubService } from '../../../services/HubService';
import { HUB_PLAYER_SPRITES } from '../../../data/hub.config';

export const HubPlayerSprite = () => {
  const speedSq = hubService.vx * hubService.vx + hubService.vy * hubService.vy;
  const moving =
    hubService.cinematicWalking ||
    speedSq > HUB_PLAYER_SPRITES.runThreshold * HUB_PLAYER_SPRITES.runThreshold;

  const waking = hubService.wakingUp && !moving;
  const spriteName = waking
    ? HUB_PLAYER_SPRITES.getUp
    : moving
      ? HUB_PLAYER_SPRITES.run
      : HUB_PLAYER_SPRITES.idle;

  return (
    <EntityDisplay
      clip={{
        spriteName,
        direction: hubService.facing,
        width: HUB_PLAYER_SPRITES.width,
        height: HUB_PLAYER_SPRITES.height,
        anchor: HUB_PLAYER_SPRITES.anchor as [number, number],
        loop: !waking,
      }}
      position={{ x: hubService.playerX, y: -hubService.playerY }}
    />
  );
};
